import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <div className="header-left">
        <a href="https://ge-room.com" target="_blank" rel="noopener noreferrer" className="logo">
          <img src="/gr-icon.svg" alt="Geroom Gallery" className="logo-icon" />
        </a>
            <Link to="/" className="home-button">
              Gallery
            </Link>
          </div>
          <div className="header-right">
            {!isAdminPage ? (
              <Link to="/admin" className="admin-button">
                <span className="admin-icon">👤</span>
              </Link>
            ) : (
              <Link to="/" className="exit-button">
                <span className="exit-icon">✕</span>
              </Link>
            )}
          </div>
        </div>
      </header>
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;
